import { Injectable } from '@angular/core';
import { Validators } from '@angular/forms';

import {
  CamAbstractInput,
  InputCheckBox,
  InputDynamicTranslation,
  InputPanel,
  InputTextBox,
} from '@camelot/form-model';
import { graphQlUpdateFields } from '@camelot/server';
import { getModifiedValues } from '@camelot/utils';

import { Activity } from '../dto/activity';
import { ActivityCreationPayloadInput } from '../dto/activity-creation-payload-input';
import { ActivityModifierPayloadInput } from '../dto/activity-modifier-payload-input';

enum EActivityFormFields {
  code = 'code',
  description = 'description',
  enabled = 'enabled',
}

@Injectable({
  providedIn: 'root',
})
export class CamActivityFormService {
  public getActivityForm(activity: Activity | null) {
    const codeInput = new InputTextBox({
      key: EActivityFormFields.code,
      label: 'organization.activities.form.code',
      readonly: !!activity,
      validators: [Validators.required],
      value: activity?.code,
    });

    const children: CamAbstractInput[] = [
      codeInput,
      new InputDynamicTranslation({
        // Édition : clé i18n fournie par le backend ; création : pas de clé (rien à charger).
        dynamicKey: activity?.descriptionTranslationKey ?? '',
        key: EActivityFormFields.description,
        label: 'organization.activities.form.translations',
        validators: [Validators.required],
      }),
    ];

    if (activity) {
      children.push(
        new InputCheckBox({
          class: 'pt-xxl',
          key: EActivityFormFields.enabled,
          label: 'organization.activities.form.enabled',
          toggle: true,
          value: activity.enabled,
        })
      );
    }

    return [
      new InputPanel({
        children,
        contentClass: 'highlight-title g-space-md',
        key: 'panel',
      }),
    ];
  }

  public activityCreateFormatForm(data: any): ActivityCreationPayloadInput {
    return {
      code: data[EActivityFormFields.code] ?? null,
      description: InputDynamicTranslation.untransformValue(data[EActivityFormFields.description]),
    };
  }

  public activityUpdateFormatForm(data: any, activity: Activity): Partial<ActivityModifierPayloadInput> {
    const modifiedData = getModifiedValues(data, activity);

    return {
      description: InputDynamicTranslation.untransformValue(data[EActivityFormFields.description]),
      enabled: modifiedData[EActivityFormFields.enabled] ?? null,
      id: activity.id,
      ...graphQlUpdateFields(modifiedData),
    };
  }
}
